<template>
  <div>
    <a-layout id="components-layout-demo-custom-trigger">

      <!--      侧边-->
      <a-layout-sider v-model="collapsed" :trigger="null"  collapsible >
        <Sider v-bind:collapsedVisible='this.collapsed'></Sider>
      </a-layout-sider>

      <!--      右边整体-->
      <a-layout>
        <!--        头部-->
        <a-layout-header class="layout-header">

          <a-row style="width: 100%">
            <a-col :span="1">
              <a-icon
                class="trigger"
                style="color: white"
                :type="collapsed ? 'menu-unfold' : 'menu-fold'"
                @click="() => (collapsed = !collapsed)"
              />
            </a-col>

            <a-col :span="10">

            <span class="layout-top-sider">

              <div v-if="menuList.includes('大屏展示')||ismanager" class="layout-top-single-sider" @click="toHeaderPage('/allDataPage/allDataPageList')">
                <img src="../img/dapingIcon.png" alt="" class="layout-top-sider-img">
                <div class="layout-top-nav-text">数据展示</div>
              </div>

              <div v-if="menuList.includes('设备管理')||ismanager" class="layout-top-single-sider" @click="toHeaderPage('/equipment/equipmentList')">
                <img src="../img/shebeiIcon.png" alt="" class="layout-top-sider-img">
                <div>设备列表</div>
              </div>

              <div v-if="menuList.includes('设备管理')||ismanager" class="layout-top-single-sider" @click="toHeaderPage('/equipment/senceList')">
                <img src="../img/touweiIcon.png" alt="" class="layout-top-sider-img">
                <div>场地展示</div>
              </div>

              <div v-if="menuList.includes('渔技服务')||ismanager" class="layout-top-single-sider" @click="toHeaderPage('/fishServe/onlineExperts/onlineExpertsList')">
                <img src="../img/zhuanjiaIcon.png" alt="" class="layout-top-sider-img">
                <div>在线专家</div>
              </div>

              <div v-if="menuList.includes('渔技服务')||ismanager" class="layout-top-single-sider" @click="toHeaderPage('/fishServe/diseaseAnalysis/diseaseAnalysisList')">
                <img src="../img/jibingIcon.png" alt="" class="layout-top-sider-img">
                <div>疾病分析</div>
              </div>
          </span>

            </a-col>

            <a-col :span="5">
              <a-dropdown class="header-right-icon-text">
                <a class="ant-dropdown-link" @click="e => e.preventDefault()" >
                  <span style="color:white;overflow:hidden; text-overflow:ellipsis; white-space:nowrap; ">当前项目：{{PlatformCurrent.cPlatformName}} </span><a-icon style="color:white" type="down" />
                </a>
                <a-menu slot="overlay">
                  <a-menu-item @click="handleplatform(item)" v-for="item in PlatformList">
                    <a  >{{item.cPlatformName}}</a>
                  </a-menu-item>
                </a-menu>
              </a-dropdown>
            </a-col>

            <a-col :span="5">
              <a-dropdown class="header-right-icon-text" style="overflow:hidden; text-overflow:ellipsis; white-space:nowrap; ">
                <a class="ant-dropdown-link" @click="e => e.preventDefault()" >
                  <span style="color:white;overflow:hidden; text-overflow:ellipsis; white-space:nowrap; ">当前场地：{{SCeneCurrent.cSceneName}} </span><a-icon style="color:white" type="down" />
                </a>
                <a-menu slot="overlay">
                  <a-menu-item @click="handlescene(item)" v-for="item in SceneList">
                    <a  >{{item.cSceneName}}</a>
                  </a-menu-item>
                </a-menu>
              </a-dropdown>
            </a-col>

            <a-col :span="1">
              <a-icon style="color: white" type="notification" class="header-right-icon" @click="toNoticePage()"/>
            </a-col>

            <a-col :span="2" style="text-align: right">
              <a-dropdown class="header-right-icon-text">
                <a class="ant-dropdown-link" @click="e => e.preventDefault()">
                  {{user.cUserName}} <a-icon type="down" />
                </a>
                <a-menu slot="overlay">
                  <a-menu-item>
                    <a @click="toHeaderPage('/systemManagement/basicInformation/basicInformationList')">企业信息</a>
                  </a-menu-item>
                  <a-menu-item>
                    <a @click="pwModal">修改密码</a>
                  </a-menu-item>
                  <a-menu-item>
                    <a @click="changeOutVisible">退出登录</a>
                  </a-menu-item>
                </a-menu>

              </a-dropdown>
            </a-col>

          </a-row>

        </a-layout-header>

<!--        修改密码弹出框-->
        <a-modal  v-model="pwModalVisible" @ok="pwHandleOk" @cancel="pwHandleCancel" :maskClosable="false" ok-text="确认" cancel-text="取消">
          <a-form-model :label-col="{ span: 5 }" :wrapper-col="{ span: 12 }">
            <a-form-model-item  label="原密码">
              <a-input v-model="userLoginModel.oldpass" type="text" />
            </a-form-model-item>
            <a-form-model-item  label="新密码">
              <a-input v-model="userLoginModel.password" type="text" />
            </a-form-model-item>
            <a-form-model-item  label="确认密码">
              <a-input v-model="userLoginModel.confirmpass" type="text" />
            </a-form-model-item>

          </a-form-model>
        </a-modal>

        <!--              弹出框-->
        <a-modal v-model="outVisible" title="注销" @ok="handleOk" ok-text="确认" cancel-text="取消">
          <p>是否退出登录？</p>
        </a-modal>

        <!--        内容-->
        <a-layout-content
          :style="{
            // margin: '24px 16px', padding: '24px', background: '#fff',
            // minHeight: '650px'
          }"
        >
          <router-view/>
        </a-layout-content>

        <a-layout-footer :style="{ textAlign: 'center' }">
          {{   user.enterprise.cEntName}}
        </a-layout-footer>

      </a-layout>
    </a-layout>
  </div>
</template>

<script>
// import { Component, Prop, Vue } from 'vue-property-decorator';
import Sider from '../components/Sider.vue'

export default {
  components: {
    Sider
  },
  data () {
    return {
      collapsed: true,
      outVisible: false,
      user: { enterprise: { cEntName: '' } },
      PlatformList: [],
      SceneList: [],
      SCeneCurrent: { ID: '', cSceneName: '' },
      PlatformCurrent: { ID: '', cPlatformName: '' },
      pwModalVisible: false,
      userLoginModel: {},
      menuList: [],
      ismanager: false
    }
  },
  created () {

  },
  mounted () {
    const that = this

    if (!this.$store.getters.User) {
      that.$router.push({ path: '/' })
    } else {
      this.user = this.$store.getters.User
      if (this.$store.getters.User.MenuList) {
        this.menuList = this.$store.getters.User.MenuList
      }
      if (this.$store.getters.User.cRoleName == '管理员') {
        this.ismanager = true
      }
    }

    this.handlePageList()
  },

  methods: {
    pwModal: function () {
      this.pwModalVisible = true
    },

    async pwHandleOk () {
      const that = this
      const user = this.utils.deepClone(that.$store.getters.User)
      if (user.cPassword == that.userLoginModel.oldpass) {
        if (that.userLoginModel.password = that.userLoginModel.confirmpass) {
          user.cPassword = that.userLoginModel.password

          const res = await that.$http.post('User/Save', user)
          if (res.data.code == '200') {
            that.$message.success('修改成功!')
            this.pwModalVisible = false
          } else {
            that.$message.error('修改失败!')
          }
        }
      } else {
        that.$message.error('原始密码错误!')
      }
    },
    pwHandleCancel: function () {
      this.pwModalVisible = false
    },
    handleOk: function () {
      this.$router.push('/')
    },
    changeOutVisible: function () {
      this.outVisible = true
    },
    toNoticePage: function () {
      this.$router.push('/notice/noticeList')
    },
    toHeaderPage: function (a, vis) {
      if (vis) {
        this.$router.push({
          path: a,
          query: {
            backButtonVisible: '1'
          }
        })
      } else {
        this.$router.push(a)
      }
      // this.$router.resolve(a)
    },
    // 切换场地
    handleplatform (obj) {
      this.$bus.$emit('platformchange', { id: obj.ID })
      this.PlatformCurrent = obj
      this.handleSceneList()
    },
    handlescene (obj) {
      this.$bus.$emit('scenechange', { id: obj.ID })
      this.SCeneCurrent = obj
    },
    async handlePageList () {
      const that = this
      const param = { cEntID: that.$store.getters.User.enterprise.ID,userID:that.$store.getters.User.ID,cSystemCode:'水产养殖' }
      //console.log('1234');
      //console.log(that.$store.getters.User.ID);
      //const res = await that.$http.post('EntPlatformInfo/List', param)
      const res = await that.$http.post('EntPlatformInfo/EnterPlatIList', param)
      if (res.data.code == '200' && res.data.obj.list.length > 0) {
        that.PlatformList = res.data.obj.list; //展示项目列表
        that.PlatformCurrent = that.PlatformList[0]; //展示当前项目名称

        that.$store.commit('setPlatForm', that.PlatformList[0])
        that.handleSceneList()
      } else {
        that.$store.commit('setPlatForm', null)
        that.$message.error(res.message)
      }
      //console.log(that.$store.getters.PlatForm)
      //console.log(that.PlatformCurrent)
    },
    async handleSceneList () {
      const that = this
      const param = { cPlatformID: that.PlatformCurrent.ID, cSystemCode: '水产养殖' }
      const res = await that.$http.post('EntSceneInfo/List', param)

      if (res.data.code == '200') {
        if (res.data.obj.list && res.data.obj.list.length > 0) {
          that.SceneList = res.data.obj.list
          that.SCeneCurrent = that.SceneList[0]
          that.$store.commit('setScene', that.SceneList[0])
        } else {
          that.SceneList = []
          that.SCeneCurrent = { ID: '', cSceneName: '' }
        }
      } else {
        that.$message.error(res.message)
      }
      that.handlescene(that.SCeneCurrent)
    }
  }

}
</script>

<style>
  .layout-header{
    /*background: #ffffff;*/
    padding: 0;
    /*border-bottom: 1px solid #e8e8e8;*/
    /*box-shadow:0px 2px 2px #f5f5f5 ;*/
    z-index: 999;
    display: flex;
    justify-content: space-between;
    width: 100%;
  }

  .header-right-icon{
    font-size: 18px;
    line-height: 64px;
    padding: 0 24px 0 24px;
    cursor: pointer;
    transition: color 0.3s;
  }

  .header-right-icon:hover{
    color: #1890ff;
  }

  .header-right-icon-text{
    /*font-size: 18px;*/
    line-height: 64px;
    padding: 0 36px 0 4px;
    cursor: pointer;
    transition: color 0.3s;
  }

  .layout-header-left-box{
    display: flex;
  }

  .layout-top-sider{
    display: flex;
    color: white;
  }

  .layout-top-single-sider{
    display: flex;
    align-items: center;
    margin-left: 25px;
    cursor: pointer;
  }

  /*.layout-top-single-sider:hover{*/
  /*  color: #1890ff;*/
  /*}*/

  .layout-top-sider-img{
    width: 16px;
    /*height: 16px;*/
    margin-right: 7px;
  }

  .layout-top-nav-text{
    /*overflow:hidden;*/

    /*text-overflow:ellipsis;*/

    /*white-space:nowrap;*/
  }

</style>
